var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconProjectLead = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.088,
    height: 14.333,
    viewBox: "0 0 15.088 14.333",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_grade_24px",
    d: "M9.544,13.52l4.662,2.814-1.237-5.3,4.119-3.568L11.664,7,9.544,2,7.424,7,2,7.462,6.119,11.03l-1.237,5.3Z",
    transform: "translate(-2 -2)",
    fill: "#727272"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconProjectLead);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-project-lead.6866cb6cb0d76cc0dcbdabdb4a1b88ab.svg";